import React from 'react';
import { Typography } from 'antd';
import classNames from 'classnames';
import Card from 'components/Card/Card';

/**
 * PageTitleBar component - Displays a page title with optional subtitle in a gradient header
 *
 * @param {Object} props
 * @param {string} props.title - The main page title
 * @param {React.ReactNode} props.subtitle - Optional subtitle content (can include custom styling)
 * @param {React.ReactNode} props.children - Optional children for custom content (rendered on the right side of title)
 * @param {string} props.className - Additional classes for the container
 */
export default function PageTitleBar({ title, subtitle, children, noChildrenPadding, extra, className, ...rest }) {
  return (
    <Card
      lightInMobile
      bordered={false}
      noBodyPadding
      className={classNames('overflow-hidden bg-gradient-to-tr from-[#1e2a90] to-[#121952]', className)}
    >
      <div
        className={classNames(
          {
            'bg-[#0b1351]': !!children,
          },
          'text-white p-8 flex flex-col md:flex-row gap-8 items-start md:items-center justify-between',
        )}
        {...rest}
      >
        <div>
          {title && (
            <Typography.Title level={1} className="!text-white !m-0 !text-3xl !font-bold">
              {title}
            </Typography.Title>
          )}

          {subtitle && <div className="text-[#b9c1ff]">{subtitle}</div>}
        </div>

        {extra && <div className="flex-shrink-0">{extra}</div>}
      </div>

      {children && (
        <div className={`text-white ${noChildrenPadding ? '' : 'p-8'} border-t border-solid border-t-[#3a4390]`}>
          {children}
        </div>
      )}
    </Card>
  );
}
